import * as Yup from 'yup';
const percentagesValidation = Yup.object({
  tipo_usuario_id: Yup.number().min(1, "Seleccione una opción").required("El tipo de usuario es requerido"),
  porcentaje: Yup.number().min(0).max(100).required("El porcentaje es requerido")
});

export default percentagesValidation;